import { useMutation } from "react-query";
import { useParams } from "react-router";
import { completeProject } from "../../../../api-services/projects/project/completeProject";
import { CompleteProjectData } from "../../../../api-types/projects/project";
import {
  FEEDBACK_TYPE,
  feedbackMessage,
} from "../../../professional/job-requests/hooks/feedbackErrors";
import { useToast } from "../../../utils/useToast";

export const useCompleteProject = () => {
  const { projectId } = useParams();
  const { notifySuccess } = useToast();

  return useMutation(
    async (completeProjectData?: CompleteProjectData) => {
      const { data } = await completeProject(projectId, completeProjectData);

      return data;
    },
    {
      onSuccess: () => {
        notifySuccess(feedbackMessage("closing request", FEEDBACK_TYPE.SUBMIT));
      },
    }
  );
};
